module.exports = __webpack_public_path__ + "static/media/simons-game.60fb7a65.png";